export default __webpack_public_path__ + "static/media/verlinde-googleplay-qr.5115eb96.jpg";